import React, { useCallback } from 'react';
import { ButtonTertiary, IconAttach } from '@spotify-internal/encore-web';
import styled from 'styled-components';
const AddAttachmentStyled = styled(ButtonTertiary) `
  &:active:hover,
  &:hover {
    color: black;
  }
`;
export const AddAttachmentButton = ({ disabled = false, onAddAttachmentClick, }) => {
    const handleAddAttachmentClick = useCallback(ev => {
        ev === null || ev === void 0 ? void 0 : ev.preventDefault();
        ev === null || ev === void 0 ? void 0 : ev.stopPropagation();
        onAddAttachmentClick === null || onAddAttachmentClick === void 0 ? void 0 : onAddAttachmentClick();
    }, [onAddAttachmentClick]);
    return (React.createElement(AddAttachmentStyled, { disabled: disabled, type: "button", "aria-label": "add attachment", iconOnly: IconAttach, onClick: handleAddAttachmentClick }));
};
//# sourceMappingURL=AddAttachmentButton.js.map